import moment from 'moment';

export const getBusinessDateFormat = (date: string | null) => {
  if (date === null) {
    return '-';
  }

  const formattedDate = moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY, h:mm:ss A');
  const [dateStr, timeStr] = formattedDate.split(', ');

  return (
    <>
      {dateStr},
      <br />
      {timeStr}
    </>
  );
};
